<script>
  import Button from "./Button.svelte";
  import { createEventDispatcher } from 'svelte';

  export let originalChildName = '';
  export let style;
  export let name;

  let childName = originalChildName;

  // console.log(childName, originalChildName)

  const dispatch = createEventDispatcher()
  const cancel = () => {procreating = false; childName = originalChildName}
  const accept = () => {dispatch('submit', childName); procreating=false; originalChildName = childName}

  let procreating = false;
</script>


{#if procreating}
  <div class="childNameHolder">
    <input bind:value={childName} on:keydown={e => e.key == 'Enter' ? accept(): e.key == 'Esc' ? cancel(): null} style='min-width: 0px'/>
    <Button on:click={cancel} >{'⨯'}</Button>
    <Button on:click={accept} disabled={childName.length == 0} >{'✓'}</Button>

  </div>
{:else}
  <Button style={style}
    on:click={() => {procreating = true;}} >{name}</Button>
{/if}

<style>
  .childNameHolder {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  } 
  .childNameHolder input {
    flex-grow: 1;
  }
</style>